import PropTypes from 'prop-types';
import React from 'react';
import { Size, Dim } from '../../constants/components';

const getFontStyle = fontSize => {
    let className = 'modal';
    if (fontSize === Size.SMALL) {
        className += ' small-font';
    }
    return className.trim();
};

const getBackgroundStyle = backgroundDim => {
    switch (backgroundDim) {
        case Dim.CENTER:
            return 'screen';
        case Dim.FULL:
            return 'dim-layout';
        default:
            return '';
    }
};

const Popup = props => (
    <div>
        <div className={getBackgroundStyle(props.backgroundDim)} />
        <div className={getFontStyle(props.fontSize)}>
            <div className="modal-header" />
            <div className="modal-body inner-border">{props.children}</div>
            <div className="modal-bottom">
                {props.buttons && <div className="popup-btnBox">{props.buttons}</div>}
            </div>
        </div>
    </div>
);

Popup.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.element]).isRequired,
    buttons: PropTypes.arrayOf(PropTypes.element),
    fontSize: PropTypes.oneOf([Size.SMALL, Size.NORMAL]),
    backgroundDim: PropTypes.oneOf([Dim.NONE, Dim.CENTER, Dim.FULL]),
};

Popup.defaultProps = {
    buttons: undefined,
    fontSize: Size.NORMAL,
    backgroundDim: Dim.NONE,
};

export default Popup;
